import React, { useContext, useEffect, useRef } from 'react';

import { ArrowRightIcon, CloseIcon } from '$partials/icon';
import { ModalContext } from '$contexts/modal.jsx';
import { useCursorContext } from '$contexts/cursor.jsx';
import { Image } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modals.d.ts').StaffModal}
 */
const StaffModal = ({
    id,
    profileImage,
    name,
    email,
    jobTitle,
    tel,
    altTel,
    biography,
}) => {
    const { handleModal } = useContext(ModalContext);

    const { dispatch: cursorDispatch } = useCursorContext();
    const exitButtonRef = useRef();
    const closeButonRef = useRef();

    useEffect(() => {
        const exit = cursorDispatch({
            type: 'registerArea',
            data: {
                ref: exitButtonRef,
                cursorType: 'exit'
            },
        });

        closeButonRef.current?.focus();

        return () => [exit].map(cleanup => {
            cleanup();});
    }, []);

    return (
        <>
            <div
                className={'fixed left-0 top-0 height-100 width-100 border-0 m0 p0 overflow-hidden bg-black mix-blend-multiply z3 cursor-none'}
                onClick={() => handleModal()}
                ref={exitButtonRef}
                style={{opacity: '0.2'}}>
            </div>
            <div
                className='height-100 bg-white z4 fixed top-0 overflow-auto modal-container'>
                <button
                    aria-label='Close'
                    className='form-field-reset link-reset absolute right-0 right mt6 mr6 cursor-pointer'
                    onClick={() => handleModal()}
                    ref={closeButonRef}
                    type='button'>
                    <CloseIcon/>
                </button>
                <div className='py7 px6'>
                    {/* Profile image */}
                    {profileImage && (
                        <div className='width-280px'>
                            <Image {...profileImage} />
                        </div>
                    )}
                    <div className='mt5 mb6 md-my5'>
                        {/* Job title */}
                        {jobTitle && (
                            <p className='type-style-5'>
                                {jobTitle}
                            </p>
                        )}
                        {/* Name */}
                        <h3 className='type-style-2 mb7'>
                            {name}
                        </h3>

                        <ul className='list-reset'>
                            {/* Tel */}
                            {tel && (
                                <li className='my2'>
                                    <a
                                        className='black type-style-6 link-reset link-underline-thin'
                                        href={`tel:${tel.replace(/\s/g, '')}`}>
                                        {tel}
                                    </a>
                                </li>
                            )}

                            {/* Alternate Tel */}
                            {altTel && (
                                <li className='my2'>
                                    <a
                                        className='black type-style-6 link-reset link-underline-thin'
                                        href={`tel:${altTel.replace(/\s/g, '')}`}>
                                        {altTel}
                                    </a>
                                </li>
                            )}

                            {/* Email */}
                            {email && (
                                <li className='my2'>
                                    <a
                                        className='black type-style-6 link-reset link-underline-thin'
                                        href={`mailto:${email}`}>
                                        {email}
                                    </a>
                                </li>
                            )}
                            {/* Download vCard */}
                            <li>
                                <a
                                    download
                                    className='black type-style-6 link-reset link-underline-thin'
                                    href={`/api/v1/vcard/${id}`}>
                                    Download vCard
                                </a>
                            </li>
                            {/* Whatsapp */}
                            {tel && (
                                <li
                                    className='my2 whatsapp'
                                    style={{ lineHeight: '32px' }}>
                                    <a
                                        className='black type-style-6 link-reset'
                                        href={`https://api.whatsapp.com/send?phone=${tel.replace(/\s/g, '').replace('+', '')}`}
                                        rel='noreferrer'
                                        target='_blank'>
                                        <span className='pr2'>Contact on WhatsApp</span>
                                        <ArrowRightIcon />
                                    </a>
                                </li>
                            )}
                        </ul>

                        {/* Biography */}
                        {biography && (
                            <div className='border-top border-black pt7 mt7'>
                                <div
                                    className='rich-text type-style-6 max-width-2'
                                    dangerouslySetInnerHTML={{ __html: biography}}/>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default StaffModal ;
